import axios from 'axios';

const client = axios.create({
  baseURL: process.env.REACT_APP_API,
  timeout: 10000,
});

// Antes de cada requisição, pega o token atualizado
client.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('tk');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Tratamento de respostas
client.interceptors.response.use(
  response => response,
  error => {
    if (error.code === 'ECONNABORTED') {
      return Promise.reject({ message: 'Tempo de resposta excedido.' });
    }
    if (!error.response) {
      return Promise.reject({ message: 'Sem conexão com o servidor.' });
    }
    const data = error.response.data;

    if (error.response.status === 401 && data.unauthenticated) {
      localStorage.removeItem('tk'); // remover token inválido
      window.location.href = '/login';
      return;
    }

    return Promise.reject(error.response.data || error);
  }
);

export default client;




// import axios from 'axios';

// let token = localStorage.getItem('tk')
// console.log(token)
// const client = axios.create({
//   baseURL: 'http://192.168.1.198:8851/api/web',
//   timeout: 5000, // 5 segundos
//   headers: {
//     'Authorization': `Bearer ${token}`
//   }
// });

// client.interceptors.response.use(
//   response => response,
//   error => {
//     if (error.code === 'ECONNABORTED') {
//       return Promise.reject({ message: 'Tempo de resposta excedido.' });
//     }
//     if (!error.response) {
//       return Promise.reject({ message: 'Sem conexão com o servidor.' });
//     }
//     const data = error.response.data;

//     if (error.response.status === 401 && data.unauthenticated) {
//       window.location.href = '/login';
//       return;
//     }

//     return Promise.reject(error.response.data || error);
//   }
// );
// export default client;



// import axios from 'axios';
// import Alertas from '../alerts/AlertasGernericos';

// const apiClient = axios.create({
//   baseURL: 'http://192.168.1.198:8851/api',
//   headers: {
//     'Accept': 'application/json',
//     'Content-Type': 'application/json'
//   }
// });


// apiClient.interceptors.request.use(
//   (config) => {
//     const token = localStorage.getItem('authToken');

//     if (token) {
//       config.headers.Authorization = `Bearer ${token}`;
//     }

//     return config;
//   },
//   (error) => {
//     return Promise.reject(error);
//   }
// );


// apiClient.interceptors.response.use(
//   (response) => {

//     const method = response.config.method.toUpperCase();
//     const message = response.data?.message;


//     if (response.status === 201 && message) {
//       Alertas.ExibirAlertaSucesso(message ?? "Operação concluida.");
//     }
    
//     // UPDATE
//     if ((method === 'PUT' || method === 'PATCH') && response.status === 200 && message) {
//       Alertas.ExibirAlertaSucesso(message ?? "Operação concluida.");
//     }

//     // DELETE
//     if (method === 'DELETE' && (response.status === 200 || response.status === 204)) {
//       Alertas.ExibirAlertaSucesso(message ?? "Item deletado com sucesso.");
//     }

//     return response;
//   },
//   (error) => {

//     if (!error.response) {
//       Alertas.ExibirAlertaErro('Não foi possível se conectar ao servidor. Verifique sua conexão.');
//       return Promise.reject(error);
//     }

//     const status = error.response.status;
//     const message = error.response.data?.message;
//     const errors = error.response.data?.errors;

//     switch (status) {
//       // **Não autorizado**: Token inválido ou expirado.
//       case 401: {
//         localStorage.removeItem('authToken');
//         localStorage.removeItem('user');
//         Alertas.ExibirAlertaErro('Sua sessão expirou. Por favor, faça login novamente.');
//         window.location.href = '/login';
//         break;
//       }


//       case 403: {
//         Alertas.ExibirAlertaErro(message || 'Você não tem permissão para executar esta ação.');
//         break;
//       }

//       case 422: {

//         console.log('teste',  message)
//         Alertas.ExibirAlertaErro(message || 'Por favor, verifique os dados informados.');
//         break;
//       }


//       case 500:
//       case 503: {
//         Alertas.ExibirAlertaErro(message || 'Ocorreu um erro inesperado no servidor. Tente novamente mais tarde.');
//         break;
//       }

//       default: {
//         Alertas.ExibirAlertaErro('Ocorreu um erro inesperado');
//       }
//     }

//     return Promise.reject(error);
//   }
// );

// export default apiClient;
